import { BookOpen, Droplets, Hand, Lightbulb, Shrimp, Sparkles, Volume2, VolumeX, ShoppingBag, Flower2, Image, Music } from 'lucide-react'

interface ActionBarProps {
  followMode: boolean
  lighting: 'day' | 'night'
  soundEnabled: boolean
  onToggleFollow: () => void
  onFeed: () => void
  onClean: () => void
  onToggleLight: () => void
  onLightShow: () => void
  onOpenCodex: () => void
  onToggleSound: () => void
  onOpenShop: () => void
  onOpenDecoration: () => void
  onOpenBackground: () => void
  onOpenAmbient: () => void
}

function IconBtn({ label, onClick, active, children }: {
  label: string
  onClick: () => void
  active?: boolean
  children: React.ReactNode
}) {
  return (
    <button
      onClick={onClick}
      title={label}
      aria-label={label}
      className={`w-12 h-12 rounded-xl flex items-center justify-center border backdrop-blur-md transition-all active:scale-90 ${
        active
          ? 'bg-sky-500 border-sky-400 text-white shadow-lg shadow-sky-300/50'
          : 'bg-white/70 border-white/80 text-slate-500 hover:bg-white hover:text-sky-600 shadow'
      }`}
    >
      {children}
    </button>
  )
}

export function ActionBar({ followMode, lighting, soundEnabled, onToggleFollow, onFeed, onClean, onToggleLight, onLightShow, onOpenCodex, onToggleSound, onOpenShop, onOpenDecoration, onOpenBackground, onOpenAmbient }: ActionBarProps) {
  return (
    <div className="flex items-center gap-3 rounded-2xl bg-white/60 border border-white/80 backdrop-blur-xl px-4 py-3 shadow-[0_10px_36px_rgba(70,140,220,0.22)]">
      <IconBtn label="图鉴" onClick={onOpenCodex}>
        <BookOpen size={20} />
      </IconBtn>
      <IconBtn label="商店" onClick={onOpenShop}>
        <ShoppingBag size={20} />
      </IconBtn>
      <IconBtn label="装饰" onClick={onOpenDecoration}>
        <Flower2 size={20} />
      </IconBtn>
      <IconBtn label="背景" onClick={onOpenBackground}>
        <Image size={20} />
      </IconBtn>
      <IconBtn label="音效" onClick={onOpenAmbient}>
        <Music size={20} />
      </IconBtn>
      <IconBtn label="换水" onClick={onClean}>
        <Droplets size={20} />
      </IconBtn>

      {/* 主按钮:逗鱼模式 */}
      <button
        onClick={onToggleFollow}
        className={`mx-1 h-12 px-7 rounded-full font-black tracking-[0.2em] text-sm whitespace-nowrap flex items-center gap-2.5 transition-all active:scale-95 border ${
          followMode
            ? 'bg-gradient-to-r from-rose-400 to-rose-500 border-rose-300 text-white shadow-[0_0_24px_rgba(244,63,94,0.45)]'
            : 'bg-gradient-to-r from-sky-400 to-blue-600 border-sky-300 text-white shadow-[0_0_24px_rgba(56,150,230,0.45)] hover:shadow-[0_0_32px_rgba(56,150,230,0.6)]'
        }`}
      >
        <Hand size={18} />
        {followMode ? '停止逗鱼' : '逗鱼模式'}
      </button>

      <IconBtn label="喂食" onClick={onFeed}>
        <Shrimp size={20} />
      </IconBtn>
      <IconBtn label={lighting === 'day' ? '夜灯' : '日灯'} onClick={onToggleLight} active={lighting === 'night'}>
        <Lightbulb size={20} />
      </IconBtn>
      <IconBtn label="光影秀" onClick={onLightShow}>
        <Sparkles size={20} />
      </IconBtn>
      <IconBtn label={soundEnabled ? '关闭音效' : '开启音效'} onClick={onToggleSound} active={!soundEnabled}>
        {soundEnabled ? <Volume2 size={20} /> : <VolumeX size={20} />}
      </IconBtn>
    </div>
  )
}
